/* Personalization fields - live character counter and the "filled" border.

   Same footing as version-selector.js and patch-selector.js: an IIFE, no framework,
   no build step. Everything here is additive decoration over inputs that already work.
   If this file fails to load, the fields still submit exactly as they do today - the
   counter simply stays empty and the border stays grey. Nothing that reaches the cart
   passes through this script.

   The counter markup is emitted by the section; this only fills it in. */

(function () {
  'use strict';

  function sync(input) {
    var max = Number(input.getAttribute('maxlength')) || 0;
    var used = input.value.length;

    input.classList.toggle('is-filled', used > 0);

    var counter = document.querySelector('[data-pers-count-for="' + input.id + '"]');
    if (!counter || !max) return;
    /* an empty field shows nothing - a "0 / 25" on an untouched form is noise */
    counter.textContent = used ? used + ' / ' + max : '';
    counter.setAttribute('data-full', String(used >= max));
  }

  function init(input) {
    if (input.dataset.persFieldReady === 'true') return;
    input.dataset.persFieldReady = 'true';
    input.addEventListener('input', function () { sync(input); });
    /* a browser-restored value on back-navigation never fires `input` */
    sync(input);
  }

  function boot() {
    document.querySelectorAll('[data-pers-field]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
